import sseRequest from "@/utils/sseRequest";
import request from "@/utils/request";
export function chatMessage(parameter, events = {}) {
  return sseRequest({
    url: "/chat-messages",
    method: "post",
    data: parameter,
    signal: events.signal,
    onmessage: events.onmessage,
    onerror: events.onerror,
  });
}
// 获取历史消息
export function getMessages(params) {
  return request({
    url: "/messages",
    method: "get",
    params,
  });
}
// 停止响应
export function stopTask(taskId, data) {
  return request({
    url: `/chat-messages/${taskId}/stop`,
    method: "post",
    data,
  });
}
// 获取建议问题列表
export function getSuggestedQuestions(messageId, params) {
  return request({
    url: `/messages/${messageId}/suggested`,
    method: "get",
    params,
  });
}
// 存储对话
export function storeQA(data) {
  return request({
    url: "/ST/store",
    method: "post",
    data,
  });
}
// 获取对话 session_id: ''
export function getStoredQA(params) {
  return request({
    url: "/ST/get",
    method: "get",
    params,
  });
}
// 查询常见问题列表
export function getCommonQuestions(params) {
  return request({
    url: `/datasets/${process.env.VUE_APP_DIFY_DATASET_ID}/documents/${process.env.VUE_APP_DIFY_DOCUMENT_ID}/segments`,
    method: "get",
    params,
    isDataSet: true
  });
}
